import { render, staticRenderFns } from "./EvalDisbursementOrders.vue?vue&type=template&id=6f5a52a0&"
import script from "./EvalDisbursementOrders.vue?vue&type=script&lang=js&"
export * from "./EvalDisbursementOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports